import { ApolloClient } from '@apollo/client/core';
import { InMemoryCache } from '@apollo/client/cache';
import { persistCache, SessionStorageWrapper } from 'apollo3-cache-persist';

export default class Client {
    constructor() {
        this.api = location.protocol + '//' + location.host + '/graphql';
        this.ready = this.init();
    }

    async init() {
        this.cache = new InMemoryCache();
        await persistCache({ cache: this.cache, storage: new SessionStorageWrapper(window.sessionStorage) });
        this.client = new ApolloClient({ uri: this.api, cache: this.cache });
    }

    async query(query, options) {
        await this.ready;
        const result = await this.client.query({ query, ...options });
        return result;
    }

    async mutate(mutation, variables, options) {
        await this.ready;
        const result = await this.client.mutate({ mutation, variables, ...options });
        return result;
    }
}